export const BACKSTAGE_COLLECTION = "backstage";

export const AUDI_DOC = "audi";
export const ADMIN_CONTROL_DOC = "adminControl";


export const ASSETS_COLLECTION = "assets";
export const ASSETS_COLLECTION_DOC = "lobby";
export const ASSETS_VEHICLE_COLLECTION_DOC = "vehicleData";
